import React, { useState } from "react";
import { Form, Collapse, message, Space, Popconfirm, Button } from "antd";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import Breadcrumb from "../../components/Breadcrumb";
import NotificationSelectElement from "../../components/NotificationSchedules/NotificationSelectElement";
import NotificationSchedulesShowElement from "../../components/NotificationSchedules/NotificationSchedulesShowElement";
import config from "../../config/email-app-config";
import RemindersSchema from "../../schema/notificationSchedules.schema";
// get hmg react query calls
import { useGetHmgs } from "../../hooks/hmg.hooks";
import { useGetProjectList } from "../../hooks/project.hooks";
import {
  useGetDocsFromMyDocs,
  useGetReminderFromReminderAPI,
  useGetReminderFromMyDocs,
  useAddReminderOnReminderAPI,
  useUpdateReminderOnReminderAPI,
  useUpdateReminderOnMyDocs,
} from "../../hooks/notificationSchedules.hooks";

const { Panel } = Collapse;

const NOTIFICATIONSCHEDULES = {
  hotelManagementGroupId: undefined,
  project: undefined,
  autoId: undefined,
  schedules: [],
};
const ERRORPRIMARYALERTRECIPIENT = "Primary Alert Recipient cannot be empty!";
const ERROREXPIRATUIONDATE = "Please select the expiration date!";
const TYPE = "CONTRACT_STORAGE_REMINDER";

const NotificationSchedule = () => {
  const [projectData, setProjectData] = useState(undefined);
  const [isMyDocsTrigger, setISMyDocsTrigger] = useState(false);
  const [isExpDateChange, setExpDateChange] = useState(false);
  const [isUpdateFields, setIsUpdateFields] = useState(false);

  const {
    control,
    handleSubmit,
    resetField,
    reset,
    watch,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(RemindersSchema),
    defaultValues: {
      notificationSchedules: NOTIFICATIONSCHEDULES,
    },
    mode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "notificationSchedules.schedules",
  });

  const { isLoading: isLoadingHMGData, data: HMGData } = useGetHmgs();
  const { data: ProjectData } = useGetProjectList();
  // Get Docs From Mydocs
  const {
    isLoading: isLoadingGetDocsFromMydocsData,
    data: GetDocsFromMydocsData,
  } = useGetDocsFromMyDocs(projectData, {
    onSuccess: (data) => {
      if (data?.data?.length === 0) {
        message.error("No Documents Available In myDocs");
      }
    },
    onError: () => {
      message.error("Server Error");
    },
  });

  const chainId = watch("notificationSchedules.autoId");
  let findReminderDataSet = {
    ...projectData,
    chainId,
  };

  // Get Reminder From Reminder API
  const {
    data: GetReminderFromReminderAPIData,
    isError: isErrorGetReminderFromReminderAPIData,
  } = useGetReminderFromReminderAPI(
    findReminderDataSet?.chainId !== undefined
      ? findReminderDataSet
      : undefined,
    {
      onSuccess: (data) => {
        resetField("notificationSchedules.schedules");
        setIsUpdateFields(true);
        // expiration date check
        if (data !== undefined) {
          setISMyDocsTrigger(false);

          let dataCheckReminderAPIData = false;
          dataCheckReminderAPIData = moment(
            data?.expirationDate,
            "MM-DD-YYYY",
          ).isAfter(moment(new Date(), "MM-DD-YYYY"));

          if (data) {
            if (dataCheckReminderAPIData === false) {
              return message.error(
                `Invalid Expiration Date ${data?.expirationDate}`,
              );
            }
            let primaryRecipientCheckArray;
            data.schedules.forEach((element) => {
              primaryRecipientCheckArray = element.primaryRecipient;
            });
            let result = primaryRecipientCheckArray?.length === 0;
            if (result === true) {
              for (
                let index = 0;
                index < Array(primaryRecipientCheckArray).length;
                index++
              ) {
                setError(
                  `notificationSchedules.schedules.[${index}].primaryRecipient`,
                  { type: "custom", message: ERRORPRIMARYALERTRECIPIENT },
                );
              }
            }
            if (data?.schedules !== undefined) {
              setIsUpdateFields(false);
              setValue(`notificationSchedules.schedules`, data?.schedules);
            }
          }
        }
      },
      onError: (error) => {
        if (error) {
          message.error(
            "Get Reminder Schedule API Error. Redirecting to myDoc`s",
          );
        }
      },
    },
  );

  // Get Reminder From mydocs
  const { data: GetReminderFromMyDocsData } = useGetReminderFromMyDocs(
    isErrorGetReminderFromReminderAPIData === true &&
      findReminderDataSet?.chainId !== undefined
      ? findReminderDataSet
      : undefined,
    {
      onSuccess: (data) => {
        resetField("notificationSchedules.schedules");
        setIsUpdateFields(true);
        // myDocs new Date()
        let myDocsExpiryDate = null;
        let primaryRecipientsMyDocs = [];
        let reminder = [];
        let additionalRecipientMyDocs;
        let autoId;
        let dataCheckMydocsData = false;
        setISMyDocsTrigger(true);

        if (data !== undefined) {
          Object.entries(data?.metaData).map(([_, value]) => {
            if (value.key === config.typeMap.expiryDate) {
              myDocsExpiryDate = moment(value.value).format("MM-DD-YYYY");
            }
            if (value.key === config.typeMap.primaryRecipient) {
              primaryRecipientsMyDocs = value.value.split(",");
            }
            if (value.key === config.typeMap.reminder) {
              reminder = value.value?.split(",");
            }
            if (value.key === config.typeMap.additionalRecipient) {
              additionalRecipientMyDocs = value.value;
            }
            if (value.key === config.typeMap.autoId) {
              autoId = value.value;
            }
          });

          if (myDocsExpiryDate === null) {
            for (let index = 0; index < reminder.length; index++) {
              myDocsExpiryDate = moment.utc(new Date()).format("MM-DD-YYYY");
              setExpDateChange(true);
              setError(
                `notificationSchedules.schedules.[${index}].expirationDate`,
                { type: "custom", message: ERROREXPIRATUIONDATE },
              );
            }
          } else {
            dataCheckMydocsData = moment
              .utc(myDocsExpiryDate, "MM-DD-YYYY")
              .isSameOrBefore(moment(new Date(), "MM-DD-YYYY"));
          }
          if (dataCheckMydocsData === true) {
            setExpDateChange(false);
            return message.error(`Invalid Expiration Date ${myDocsExpiryDate}`);
          }
          if (reminder.length > 0) {
            setIsUpdateFields(false);
            let dataMydocs = [];
            reminder.forEach((spittedReminderDays) =>
              dataMydocs.push({
                autoId,
                type: TYPE,
                expirationDate: myDocsExpiryDate,
                scheduleSet: false,
                reminderDays: spittedReminderDays,
                reminderDate: moment
                  .utc(myDocsExpiryDate, "MM-DD-YYYY")
                  .subtract(spittedReminderDays, "days")
                  .local()
                  .format("MM-DD-YYYY"),
                primaryRecipient: primaryRecipientsMyDocs,
                secondaryRecipient:
                  additionalRecipientMyDocs === ""
                    ? []
                    : additionalRecipientMyDocs.split(","),
              }),
            );
            setValue(`notificationSchedules.schedules`, dataMydocs);

            let result =
              primaryRecipientsMyDocs.filter((item) => item === "").length ===
              0;

            if (result === false) {
              for (let index = 0; index < reminder.length; index++) {
                setError(
                  `notificationSchedules.schedules.[${index}].primaryRecipient`,
                  { type: "custom", message: ERRORPRIMARYALERTRECIPIENT },
                );
              }
            }
          }
        }
      },
      onError: () => {
        message.error("Unable to Get Reminders from myDoc`s");
      },
    },
  );

  // console.log(fields, "fields");

  // Submit Functions - Scheduler api /myDoc`s
  // Scheduler react query call Options
  const QueryOptions = {
    onSuccess: (dataResponce) => {
      message.success(dataResponce.message);
      reset();
      setProjectData(undefined);
      setIsUpdateFields(false);
      findReminderDataSet = undefined;
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  };

  // Add data to Reminder API
  const { mutate: mutateAddReminderOnReminderAPI } =
    useAddReminderOnReminderAPI(QueryOptions);
  // update data to Reminder API
  const { mutate: mutateUpdateReminderOnReminderAPI } =
    useUpdateReminderOnReminderAPI(QueryOptions);
  // Add data to Mydocs
  const { mutate: mutateUpdateReminderOnMyDocs } =
    useUpdateReminderOnMyDocs(QueryOptions);

  const onSubmitData = (data) => {
    //    console.log(data, "data");

    const AppExpirationDate = data?.notificationSchedules?.schedules?.map(
      (x) => x.expirationDate,
    );
    const AppAutoId = fields?.map((x) => x.autoId);

    const { entityId } = findReminderDataSet;
    const { projectId } = findReminderDataSet;
    const expirationDate = AppExpirationDate[0];
    const deleted = GetReminderFromReminderAPIData?.deleted
      ? GetReminderFromReminderAPIData?.deleted
      : false;
    const autoId = AppAutoId[0]
      ? AppAutoId[0]
      : GetReminderFromReminderAPIData.autoId;
    const schedules = data?.notificationSchedules?.schedules;

    const valuesSetReminderAPI = {
      entityId,
      projectId,
      chainId,
      expirationDate,
      deleted,
      autoId,
      schedules,
    };

    // console.log("Send values of form to scheduler api:", valuesSetReminderAPI);

    const valuesSetMydocs = {
      metaData: [
        {
          key: config.typeMap.autoId,
          value: autoId,
        },
        {
          key: config.typeMap.expiryDate,
          value: expirationDate,
        },
        {
          key: config.typeMap.reminder,
          value: data?.notificationSchedules?.schedules
            .map((e) => e.reminderDays)
            .join(",")
            .toString(),
        },
        {
          key: config.typeMap.primaryRecipient,
          value: data?.notificationSchedules?.schedules
            .flatMap((item) => item.primaryRecipient)
            .filter((value, index, self) => self.indexOf(value) === index)
            .toString(),
        },
        {
          key: config.typeMap.additionalRecipient,
          value: data?.notificationSchedules?.schedules
            .flatMap((e) => e.secondaryRecipient)
            .filter((value, index, self) => self.indexOf(value) === index)
            .toString(),
        },
      ],
    };

    // console.log("myDocs", valuesSetMydocs);

    try {
      if (isMyDocsTrigger === true) {
        mutateAddReminderOnReminderAPI({
          findReminderDataSet,
          data: valuesSetReminderAPI,
        });
      } else {
        mutateUpdateReminderOnReminderAPI({
          findReminderDataSet,
          data: valuesSetReminderAPI,
        });
      }
      mutateUpdateReminderOnMyDocs({
        findReminderDataSet,
        data: valuesSetMydocs,
      });
    } catch (e) {
      message.error("Server Error");
      console.log(e);
    }
  };

  // console.log(errors, "errors");

  const onReset = () => {
    reset();
    setProjectData(undefined);
    setIsUpdateFields(false);
  };
  return (
    <div>
      <div className="container_aa">
        <h3>Reminders</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            { path: "Reminders", breadcrumbName: "Reminders " },
          ]}
        />
      </div>

      <div className="container_ab">
        <div className="container_style_1_b" style={{ width: "100%" }}>
          <form onSubmit={handleSubmit(onSubmitData)}>
            <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
              <Panel header="Reminders" key="1">
                <NotificationSelectElement
                  Form={Form}
                  control={control}
                  errors={errors}
                  config={config}
                  HMGData={HMGData}
                  isLoadingHMGData={isLoadingHMGData}
                  ProjectData={ProjectData}
                  isLoadingGetDocsFromMydocsData={
                    isLoadingGetDocsFromMydocsData
                  }
                  Controller={Controller}
                  setProjectData={setProjectData}
                  GetDocsFromMydocsData={GetDocsFromMydocsData}
                  resetField={resetField}
                  watch={watch}
                />

                <div className="container_style_1_b">
                  <div className="is_table_3">
                    {(GetReminderFromReminderAPIData ||
                      GetReminderFromMyDocsData) !== undefined &&
                    isUpdateFields === false ? (
                      <NotificationSchedulesShowElement
                        Form={Form}
                        control={control}
                        errors={errors}
                        config={config}
                        Controller={Controller}
                        fields={fields}
                        append={append}
                        remove={remove}
                        GetReminderFromReminderAPIData={
                          GetReminderFromReminderAPIData
                        }
                        GetReminderFromMyDocsData={GetReminderFromMyDocsData}
                        setExpDateChange={setExpDateChange}
                        isExpDateChange={isExpDateChange}
                        setISMyDocsTrigger={setISMyDocsTrigger}
                        setValue={setValue}
                        watch={watch}
                      />
                    ) : null}
                  </div>
                </div>
              </Panel>
            </Collapse>
            <Form.Item
              style={{
                textAlign: "center",
                paddingTop: "20px",
              }}
            >
              <Space>
                <Popconfirm title="Sure to Reset?" onConfirm={onReset}>
                  <Button htmlType="submit">CANCEL</Button>
                </Popconfirm>

                <Button
                  type="primary"
                  disabled={
                    fields?.length === 0 ||
                    Object.keys(errors).length !== 0 ||
                    isExpDateChange === true ||
                    isUpdateFields === true
                  }
                  htmlType="submit"
                >
                  UPDATE
                </Button>
              </Space>
            </Form.Item>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NotificationSchedule;
